import { useState } from "react";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import * as MuiIcons from '@mui/icons-material';

/**
 * IrParaAction
 */

type Props = {
  id: number;
  icon: keyof typeof MuiIcons;
  label: string;
  onExecuteAction: (idAction: number, openNewTab: boolean) => void;
};

export const IrParaAction = ({
  id,
  icon,
  label,
  onExecuteAction,
}: Props) => {
  const [hover, setHover] = useState(false);

  return (
    <span
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onMouseDown={e => {
        if (e.button === 1) {
          onExecuteAction(id, true);
        } else {
          onExecuteAction(id, e.ctrlKey);
        }
        e.preventDefault();
      }}
      className="flex flex-col justify-center items-center aspect-square border border-[#009C4E] hover:border-[#f58634] text-[#009C4E] hover:text-[#f58634] rounded p-2 gap-2 cursor-pointer">
      <span>
        <DynamicIcon
          nameIcon={icon}
          size={45} />
      </span>
      <span
        className={`flex flex-row justify-center items-center text-center text-[.75rem] h-[2.25rem] ${hover ? 'text-[#f58634]' : 'text-black dark:text-white'}`}>
        {label}
      </span>
    </span>
  );
}